import React, { Component } from 'react';
import Loading from '../../components/loading/loading';
import HtmlParse from 'html-react-parser';
import { Query } from 'react-apollo';
import { ABOUT_VARIABLES, ABOUT_QUERY } from '../../query/about';
import { Helmet } from 'react-helmet';

class AboutPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="static-page-container">
        <Query variables={ABOUT_VARIABLES} query={ABOUT_QUERY}>
          {({ data, loading, error }) => {
            if (loading || !data) {
              return <Loading />;
            } else if (error) console.error(error);
            else {
              return (
                <div className="about-container">
                  <Helmet>
                    <title>{data.SuperContent.Title} - Radyo D</title>
                  </Helmet>
                  <h2>{data.SuperContent.Title}</h2>
                  {HtmlParse(data.SuperContent.Text)}
                </div>
              );
            }
          }}
        </Query>
      </div>
    );
  }
}

export default AboutPage;
